document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.tr-multistep-contact');
  if (!sections.length) return;

  sections.forEach((wrapper) => {
    const form = wrapper.querySelector('.tr-multistep-contact__form');
    const steps = wrapper.querySelectorAll('.tr-multistep-contact__step');
    const finalScreen = wrapper.querySelector('.tr-multistep-contact__final');
    const progressFill = wrapper.querySelector('.tr-multistep-contact__progress-fill');
    const indicator = wrapper.querySelector('[data-step-indicator]');
    const prevBtn = wrapper.querySelector('[data-step-prev]');
    const nextBtn = wrapper.querySelector('[data-step-next]');

    if (!form || !steps.length || !progressFill || !indicator || !prevBtn || !nextBtn) {
      return;
    }

    let currentIndex = 0;
    const total = steps.length;
    let onFinal = false;

    const updateUI = () => {
      steps.forEach((step, index) => {
        const isActive = !onFinal && index === currentIndex;
        step.classList.toggle('is-active', isActive);
      });

      if (finalScreen) {
        finalScreen.classList.toggle('is-active', onFinal);
      }

      let percent = 0;
      if (total > 1) {
        percent = (currentIndex / (total - 1)) * 100;
      }
      progressFill.style.width = `${percent}%`;
      indicator.textContent = `${currentIndex + 1} / ${total}`;

      if (currentIndex === 0 && !onFinal) {
        prevBtn.disabled = true;
        prevBtn.classList.add('tr-multistep-contact__nav-btn--disabled');
      } else {
        prevBtn.disabled = false;
        prevBtn.classList.remove('tr-multistep-contact__nav-btn--disabled');
      }

      if (onFinal || currentIndex === total - 1 && !finalScreen) {
        nextBtn.disabled = true;
        nextBtn.classList.add('tr-multistep-contact__nav-btn--disabled');
      } else {
        nextBtn.disabled = false;
        nextBtn.classList.remove('tr-multistep-contact__nav-btn--disabled');
      }
    };

    prevBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (onFinal && finalScreen) {
        onFinal = false;
        currentIndex = total - 1;
        updateUI();
        return;
      }

      if (currentIndex > 0) {
        currentIndex -= 1;
        updateUI();
      }
    });

    nextBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (!onFinal && currentIndex === total - 1 && finalScreen) {
        onFinal = true;
        updateUI();
        return;
      }

      if (currentIndex < total - 1) {
        currentIndex += 1;
        updateUI();
      }
    });

    updateUI();
  });

  // On phones the closed Odoo chat bubble sits on the step buttons, so it's hidden while a form
  // card is on screen. An open chat (anything in the widget taller than the bubble) stays put.
  const cards = document.querySelectorAll('.tr-multistep-contact__card');
  if (!cards.length || !('IntersectionObserver' in window)) return;

  const phone = window.matchMedia('(max-width: 749px)');
  const cardsOnScreen = new Set();
  const root = document.documentElement;

  const chatIsOpen = () => {
    const shadow = document.querySelector('.o-livechat-root')?.shadowRoot;
    if (!shadow) return false;
    return [...shadow.querySelectorAll('*')].some((element) => element.getBoundingClientRect().height > 120);
  };

  const updateChat = () => {
    const hide = phone.matches && cardsOnScreen.size > 0;
    if (hide && !root.classList.contains('tr-chat-over-form') && chatIsOpen()) return;
    root.classList.toggle('tr-chat-over-form', hide);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) cardsOnScreen.add(entry.target);
      else cardsOnScreen.delete(entry.target);
    });
    updateChat();
  });
  cards.forEach((card) => observer.observe(card));
  phone.addEventListener('change', updateChat);
});


